
export default {
    namespaced: true,  
    state: {

    },
    getters: {
    },
    actions: {

    },
    mutations: {
        SOCKET_CONNECT(state) {
            console.log('connected')
        },
      
        SOCKET_DISCONNECT(state) {
;
        },
      
        SOCKET_MESSAGECHANNEL(state, message) {
        }
    }
}